import { TextTestID } from "@/constants/TestID";
import Text from "@/ui/core/Text";
import { VStack } from "@/ui/layout/Stacks";
import { joinTestIDs } from "@/utils/string.util";

interface EmptyListContentProps extends BaseViewProps {
  isCentered?: boolean;
  paragraphs?: string[];
  title: string;
}

const EmptyListContent = ({
  isCentered,
  paragraphs,
  testID,
  title,
}: EmptyListContentProps) => {
  const baseTestID = joinTestIDs(testID, TextTestID.EmptyList);
  return (
    <VStack alignItems={isCentered ? "center" : undefined} gap={8}>
      <Text
        testID={joinTestIDs(baseTestID, TextTestID.Title)}
        variant="bodyMedium"
      >
        {title}
      </Text>

      {/* eslint-disable-next-line max-params */}
      {paragraphs?.map((paragraph, index) => {
        const paragraphTestID = joinTestIDs(
          baseTestID,
          TextTestID.Description,
          index.toString(),
        );
        return (
          <Text
            key={paragraphTestID}
            testID={paragraphTestID}
            variant="caption"
          >
            {paragraph}
          </Text>
        );
      })}
    </VStack>
  );
};

export default EmptyListContent;
